import React from 'react';
import { useAuth } from '../auth/AuthProvider';
import { Avatar, Card, ListItem, PageHeader, Screen, Text, useShell, useTheme } from '../ui';
import { navSections } from './registry';
import { TAB_NAMES } from './tabs';

/** Phone "More" tab: every permitted screen not already a tab, grouped by section. */
export function MoreScreen() {
  const { me, can, logout } = useAuth();
  const { go } = useShell();
  const { dark, toggle } = useTheme();
  const groups = navSections(can, TAB_NAMES);
  return (
    <Screen>
      <PageHeader title="More" />
      <Card flush>
        <ListItem
          divider={false}
          left={<Avatar name={me?.name ?? '?'} size={40} />}
          title={me?.name ?? ''}
          subtitle={[me?.employee?.designation, me?.tenant?.name].filter(Boolean).join(' · ')}
          onPress={can('ess.self') ? () => go('MyProfile') : undefined}
          chevron={can('ess.self')}
        />
      </Card>
      {groups.map((g) => (
        <Card key={g.key} title={g.label} flush>
          {g.items.map((s, i) => (
            <ListItem key={s.name} icon={s.icon} title={s.title} onPress={() => go(s.name)} chevron divider={i < g.items.length - 1} testID={`more-${s.name}`} />
          ))}
        </Card>
      ))}
      <Card flush>
        <ListItem icon={dark ? 'sun' : 'moon'} title={dark ? 'Light mode' : 'Dark mode'} onPress={toggle} />
        <ListItem icon="logout" title="Sign out" onPress={logout} divider={false} />
      </Card>
      <Text variant="small" align="center">
        Helios HRMS · {me?.tenant?.code}
      </Text>
    </Screen>
  );
}
